var map = {
	"./ACCESS_LOCKED.mp3": "57b4",
	"./ALARM_CLOCK.mp3": "967d",
	"./BUTTON_SWITCH.mp3": "11a0",
	"./CONFIRM.mp3": "5e33",
	"./ERROR.mp3": "f256",
	"./INFO.mp3": "2a3f",
	"./LogOFF.mp3": "4c10",
	"./LogON.mp3": "8ba6",
	"./MESSAGE.mp3": "96c2",
	"./NewOrder.mp3": "3cf1",
	"./WARNING.mp3": "cdfc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba5b";